import { render, staticRenderFns } from "./DashboardChart.vue?vue&type=template&id=c787cacc&scoped=true&"
import script from "./DashboardChart.vue?vue&type=script&lang=ts&"
export * from "./DashboardChart.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardChart.vue?vue&type=style&index=0&id=c787cacc&prod&scoped=true&lang=sass&"
import style1 from "./DashboardChart.vue?vue&type=style&index=1&id=c787cacc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c787cacc",
  null
  
)

export default component.exports